module.exports = __webpack_public_path__ + "static/media/responsabile-direzione.e202f52b.odt";